import { createContext, useContext } from 'react';
import type { StorefrontProduct } from '../../api/client';

export const ProductContext = createContext<StorefrontProduct | null>(null);
// Every repeated card receives its own product without changing the stored element template.
export const useProduct = () => useContext(ProductContext);

/** The variant and quantity chosen inside one product scope, shared by its buy box and an order form beside it. */
export type ProductChoice = {
  selected: string; select: (id: string) => void; quantity: number; setQuantity: (quantity: number) => void;
  /** True inside a product block; outside one there is no choice, only the page's own product. */
  scoped: boolean;
};

export const VariantContext = createContext<ProductChoice>({ selected: '', select: () => {}, quantity: 1, setQuantity: () => {}, scoped: false });
// Variant selection also updates bound price and compare-at price in the same product scope.
export const useProductVariant = () => useContext(VariantContext);
